import { EMPTY_OBJECT } from '../../../constants/common'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getEmailTemplates } from '../Email.api'
import { EmailTemplateSelectDropdownListItem } from '../EmailTemplateSelectDropdownListItem'

import {
  getEmailTemplateSelectApiData,
  toEmailTemplateSelectItems,
} from './EmailTemplateSelect.utils'

function EmailTemplateSelect({
  Control = InputSelectControl,
  getData = getEmailTemplates,
  getDataItems = getEmailTemplateSelectApiData,
  listProps: {
    Item = EmailTemplateSelectDropdownListItem,
    ...listProps
  } = EMPTY_OBJECT,
  toPreparedItems = toEmailTemplateSelectItems,
  ...restProps
}) {
  return (
    <>
      <InputAsyncSelect
        {...restProps}
        Control={Control}
        getData={getData}
        getDataItems={getDataItems}
        listProps={{ Item, ...listProps }}
        toPreparedItems={toPreparedItems}
      />
    </>
  )
}

export default EmailTemplateSelect
